export default {
    name: 'locked',
    data() {
        return {
            buttonClasses: ['is-fullwidth']
        };
    },
    methods: {
        // Transition to LoginForm on click of Back to Login link.
        onClickBackToLogin(e) {
            e.preventDefault();
            this.$emit('currentView', 'login-form');
            this.$emit('currentTransition', 'component-slide-fade-down');
            this.$emit('currentAlert', null);
        }
    }
};
